import { z } from "zod";

export const getOrderTemplateParamSchema = z.object({
	orderTemplateId: z.uuid(),
});

export type GetOrderTemplateParamSchema = z.infer<typeof getOrderTemplateParamSchema>;
